import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  dialogContainer: {
    backgroundColor: theme.vars.palette.transparent.a25,
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '100%',
        maxWidth: '80rem'
      }
    }
  },
  fixedToggleHeader: {
    backgroundColor: theme.vars.palette.background.elevation2
  },
  diffLegent: {
    display: 'contents',
    '& div': {
      width: '1rem',
      height: '1rem',
      marginRight: '.5rem',
      borderRadius: '.25rem'
    }
  },
  syncInfo: {
    paddingTop: '1rem'
  },
  toggleButtons: {
    position: 'absolute',
    top: '.5rem',
    right: '1rem'
  },
  legend: {
    position: 'absolute',
    top: '0',
    height: '3rem',
    right: '5rem',
    width: '18rem',
    display: 'flex',
    alignItems: 'center'
  }
}));

export default useStyles;
